import React from 'react'
import "./AcademyWhyChoose.css"
import AcademyWhyChooseHead from './AcademyWhyChooseHead'
import AcademyWhyChooseMain from './AcademyWhyChooseMain'
const AcademyWhyChoose = () => {

  return (
    <div className="academyWhyChoose-container">
      <AcademyWhyChooseHead/>
      <AcademyWhyChooseMain/>
    </div>
  )
}

export default AcademyWhyChoose
